import Vue from 'vue';
// v-dialogCenter: 弹窗居中
Vue.directive('dialogCenter', {
  bind(el, binding, vnode, oldVnode) {
    const dragDom = el.querySelector('.el-dialog');
    const attrStyle = dragDom.style.cssText;
    dragDom.style.cssText += `;opacity:0;`;
    const setStyle = () => {
      if (!dragDom.offsetWidth) {
        setTimeout(() => {
          setStyle();
        }, 20);
      } else {
        let style = `${attrStyle}top:${(window.innerHeight - dragDom.offsetHeight) / 2}px;`;
        style += `left:${(window.innerWidth - dragDom.offsetWidth) / 2}px;`;
        dragDom.style.cssText = style;
      }
    };
    setStyle();
  }
});
// v-dialogDrag: 弹窗拖拽属性 参数key 记住上次拖放的位置
Vue.directive('dialogDrag', {
  bind(el, binding, vnode, oldVnode) {
    var _binding$value;
    const dialogHeaderEl = el.querySelector('.el-dialog__header');
    const dragDom = el.querySelector('.el-dialog');
    if ((_binding$value = binding.value) !== null && _binding$value !== void 0 && _binding$value.key) {
      var _binding$value2;
      const style = window.sessionStorage.getItem((_binding$value2 = binding.value) === null || _binding$value2 === void 0 ? void 0 : _binding$value2.key);
      dragDom.style.cssText += style;
      // @ts-ignore
      window.dialogStyle = dragDom.style.cssText;
    }
    dialogHeaderEl.style.cssText += ';cursor:move;';
    // 获取原有属性 ie dom元素.currentStyle 火狐谷歌 window.getComputedStyle(dom元素, null);
    const sty = (() => {
      // @ts-ignore
      if (window.document.currentStyle) {
        return (dom, attr) => dom.currentStyle[attr];
      } else {
        return (dom, attr) => getComputedStyle(dom, null)[attr];
      }
    })();
    dialogHeaderEl.onmousedown = e => {
      // 鼠标按下，计算当前元素距离可视区的距离
      const disX = e.clientX - dialogHeaderEl.offsetLeft;
      const disY = e.clientY - dialogHeaderEl.offsetTop;
      const screenWidth = document.body.clientWidth; // body当前宽度
      const screenHeight = document.documentElement.clientHeight; // 可见区域高度(应为body高度，可某些环境下无法获取)
      const dragDomWidth = dragDom.offsetWidth; // 对话框宽度
      const dragDomheight = dragDom.offsetHeight; // 对话框高度
      const minDragDomLeft = dragDom.offsetLeft;
      const maxDragDomLeft = screenWidth - dragDom.offsetLeft - dragDomWidth;
      const minDragDomTop = dragDom.offsetTop;
      const maxDragDomTop = screenHeight - dragDom.offsetTop - dragDomheight;
      // 获取到的值带px 正则匹配替换
      let styL = sty(dragDom, 'left');
      let styT = sty(dragDom, 'top');
      // 注意在ie中 第一次获取到的值为组件自带50% 移动之后赋值为px
      if (styL.includes('%')) {
        styL = +document.body.clientWidth * (+styL.replace(/\%/g, '') / 100);
        styT = +document.body.clientHeight * (+styT.replace(/\%/g, '') / 100);
      } else {
        styL = +styL.replace(/\px/g, '');
        styT = +styT.replace(/\px/g, '');
      }
      document.onmousemove = event => {
        var _binding$value3;
        // 通过事件委托，计算移动的距离
        let left = event.clientX - disX;
        let top = event.clientY - disY;
        // 边界处理
        if (-left > minDragDomLeft) {
          left = -minDragDomLeft;
        } else if (left > maxDragDomLeft) {
          left = maxDragDomLeft;
        }
        if (-top > minDragDomTop) {
          top = -minDragDomTop;
        } else if (top > maxDragDomTop) {
          top = maxDragDomTop;
        }
        // 移动当前元素
        dragDom.style.cssText += `;left:${left + styL}px;top:${top + styT}px;`;
        if ((_binding$value3 = binding.value) !== null && _binding$value3 !== void 0 && _binding$value3.key) {
          var _binding$value4;
          window.sessionStorage.setItem((_binding$value4 = binding.value) === null || _binding$value4 === void 0 ? void 0 : _binding$value4.key, dragDom.style.cssText);
        }
        // @ts-ignore
        window.dialogStyle = dragDom.style.cssText;
      };
      document.onmouseup = () => {
        document.onmousemove = null;
        document.onmouseup = null;
      };
    };
  }
});
// v-dialogDragSize: 弹窗拖大 拖小
Vue.directive('dialogDragSize', {
  bind(el, binding, vnode, oldVnode) {
    const dragDom = el.querySelector('.el-dialog');
    const iconDom = document.createElement('div');
    el.querySelector('.el-dialog').appendChild(iconDom);
    iconDom.classList = ['ce-drag-size'];
    iconDom.innerHTML = '<span class="iconfont icon-suofang"></span>';
    iconDom.onmousedown = e => {
      // 鼠标按下，计算当前元素距离可视区的距离+
      const disW = dragDom.clientWidth;
      const disH = dragDom.clientHeight;
      const disX = e.clientX;
      const disY = e.clientY;
      iconDom.classList = ['ce-drag-size active'];
      document.onmousemove = event => {
        event.preventDefault(); // 移动时禁用默认事件
        // 计算移动后的左偏移量和顶部的偏移量
        // 通过事件委托，计算移动的距离
        if (e.clientY - disY + disH <= 280) {
          return false;
        }
        dragDom.style.width = `${event.clientX - disX + disW}px`;
        dragDom.style.height = `${event.clientY - disY + disH}px`;
        // @ts-ignore
        window.dialogStyle = dragDom.style.cssText;
      };
      document.onmouseup = () => {
        iconDom.classList = ['ce-drag-size'];
        document.onmousemove = null;
        document.onmouseup = null;
      };
    };
  }
});